import React from 'react';
import { useTranslation } from 'react-i18next';
import { FurnitureEditorContext } from '../../../lib/constraintsChecker/FurnitureEditor';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../../../containers/Header/types';
import { makeSelectContext } from '../../../containers/Configurator/selectors/general';
import { useSelector } from 'react-redux';

// import styled from 'styled-components';

interface StateProps {
  context: FurnitureEditorContext;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  context: makeSelectContext(),
});

const CrashMessage = () => {
  const { t } = useTranslation();
  const { context } = useSelector(stateSelector);
  return (
    <>
      <div className="my-2 text-lg">
        {t('Unfortunately, the configurator encounter a problem')}
      </div>
      <div>{t("We'll sort it out as soon as possible")}</div>

      {context !== FurnitureEditorContext.webShop ? (
        <a
          href="https://desk.kewlox.com/servicedesk/customer/portal/3/create/26"
          target="_blank"
          className="py-2 px-2 cursor-pointer text-lg font-semibold border"
        >
          {t('Click here to inform the developers')}
        </a>
      ) : (
        <button
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            location.reload();
          }}
        >
          {t('Restoring your furniture')}
        </button>
      )}
    </>
  );
};

export default CrashMessage;
